import { useContext } from "react"
import { FormProvider, useForm } from "react-hook-form"
import SeoContainer from "~/components/Seo/SeoContainer"
import UnsavedChanges from "~/components/Seo/UnsavedChanges"
import { SEO_SCHEMA } from "~/constants/seo"
import CertificationContext from "~/contexts/Certification"
import useSetSeoMutation from "~/hooks/useSetSeoMutation"
import useYupValidationResolver from "~/hooks/useYupValidationResolver"

const seoSchema = SEO_SCHEMA

const Seo = () => {
  const { certification } = useContext(CertificationContext)
  const { mutateAsync, isLoading } = useSetSeoMutation({
    type: "certification",
    type_id: certification.id,
  })

  const onSubmitHandler = async (data) => {
    await mutateAsync(data).then((res) => {
      methods.reset({
        title: res.title ?? "",
        description: res.description ?? "",
        image: res.image ?? "",
      })
    })
  }
  const resolver = useYupValidationResolver(seoSchema)
  const methods = useForm({
    resolver,
    defaultValues: {
      title: certification?.seo?.title || "",
      description: certification?.seo?.description || "",
      image: certification?.seo?.image || {},
    },
  })

  return (
    <FormProvider {...methods}>
      <SeoContainer onSubmitHandler={methods.handleSubmit(onSubmitHandler)} />
      <UnsavedChanges
        onSubmitHandler={methods.handleSubmit(onSubmitHandler)}
        isLoading={isLoading ?? false}
      />
    </FormProvider>
  )
}

export default Seo
